// Filing status labels exactly as sent by the backend (filings-by-status API).
export const FILING_STATUS = {
  IN_QUEUE: "In Queue",
  TAX_PREPARER_ASSIGNED: "Tax Preparer Assigned",
  PREPARATION_IN_PROGRESS: "Preparation in Progress",
  INTERNAL_REVIEW: "Internal Review",
  READY_TO_FILE: "Ready to File",
  FILED: "Filed",
  ON_HOLD: "On Hold",
  AMENDMENT: "Amendment",
} as const;

export type FilingStatus = (typeof FILING_STATUS)[keyof typeof FILING_STATUS];

// Dot colour per status; unknown statuses fall back to DEFAULT_DOT_CLASS.
export const FILING_STATUS_DOT_CLASS: Record<FilingStatus, string> = {
  [FILING_STATUS.IN_QUEUE]: "t-bg-blue-70",
  [FILING_STATUS.TAX_PREPARER_ASSIGNED]: "t-bg-blue-70",
  [FILING_STATUS.PREPARATION_IN_PROGRESS]: "t-bg-blue-70",
  [FILING_STATUS.INTERNAL_REVIEW]: "t-bg-blue-70",
  [FILING_STATUS.READY_TO_FILE]: "t-bg-purple",
  [FILING_STATUS.FILED]: "t-bg-green-55",
  [FILING_STATUS.ON_HOLD]: "t-bg-orange-70",
  [FILING_STATUS.AMENDMENT]: "t-bg-orange-70",
};

export const DEFAULT_DOT_CLASS = "t-bg-neutral-40";

const isFilingStatus = (status: string): status is FilingStatus =>
  status in FILING_STATUS_DOT_CLASS;

export const getFilingStatusDotClass = (status: string): string =>
  isFilingStatus(status) ? FILING_STATUS_DOT_CLASS[status] : DEFAULT_DOT_CLASS;
